/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiCampaignsSortOrder = (typeof GetApiCampaignsSortOrder)[keyof typeof GetApiCampaignsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCampaignsSortOrder = {
    ASC: 'ASC',
    DESC: 'DESC',
} as const;
